import React from "react";
import PropTypes from "prop-types";
import { Tooltip, OverlayTrigger } from "react-bootstrap";
import classNames from "classnames";
import utils from "@utils";
import "./TimeHoverTooltip.scss";

const TimeHoverTooltip = ({ item, TimeZoneId, user, disputed }) => {
	const { lang } = global;
	const buttonClass = classNames(
		"btn", {
		"btn-link": !disputed,
		"btn-link-danger": disputed,
	})
	const timeClassName = classNames("padding-left-0", buttonClass)

	const tooltip = (
		<Tooltip
			id="time-tooltip"
			className="custom-tooltip"
		>
			<div className="tooltip-section">
				<div>
					<strong>{lang.t("Scheduled Time")}</strong>
				</div>
				<div>
					{utils.splitDateTimeRange(
						item.JobStartTime,
						item.JobEndTime,
						TimeZoneId,
						user.UserPreferences === "useMilitaryTime",
					)}
				</div>
			</div>
			<div className="tooltip-section">
				<div>
					<strong>{lang.t("Actual Clock In / Clock Out Time")}</strong>
				</div>
				<div>
					{utils.splitDateTimeRange(
						item.CheckinDateTimeUTC,
						item.CheckoutDateTimeUTC,
						TimeZoneId,
						user.UserPreferences === "useMilitaryTime",
					)}
				</div>
			</div>
			<div className="tooltip-section">
				<div>
					<strong>{lang.t("Submitted Timecard")}</strong>
				</div>
				<div>
					{utils.splitDateTimeRange(
						item.TimeCard?.ClockInTime,
						item.TimeCard?.ClockOutTime,
						TimeZoneId,
						user.UserPreferences === "useMilitaryTime",
					)}
				</div>
			</div>
		</Tooltip>
	);

	return (
		<OverlayTrigger
			placement="bottom"
			overlay={tooltip}
			trigger={["hover", "focus"]}
			popperConfig={{
				modifiers: [
					{ name: "arrow", options: { element: null } },
					{ name: "offset", options: { offset: [0, 8] } },
				],
			}}
		>
			<span className={timeClassName}>
				{utils.splitDateTimeRange(
					item.JobStartTime,
					item.JobEndTime,
					TimeZoneId,
					user.UserPreferences === "useMilitaryTime",
				)}
			</span>
		</OverlayTrigger>
	);
};

TimeHoverTooltip.propTypes = {
	item: PropTypes.object.isRequired,
	TimeZoneId: PropTypes.number.isRequired,
	user: PropTypes.object.isRequired,
	disputed: PropTypes.bool,
};

TimeHoverTooltip.defaultProps = {
	disputed: false,
};

export default TimeHoverTooltip;
